'use client';

import SvgChevronRight from '@hc-frontend/core-icons/kit/chevron-right';
import { addClassName } from '@hc-frontend/core-utils-format';
import React, { useState } from 'react';

import type { AccordionProps } from './accordion.types';

export function Accordion({
  id,
  title,
  children,
  defaultValue = false,
  triggerClassName,
  triggerIconClassName,
  open: openControlled,
  toggle: toggleControlled,
  ref,
}: AccordionProps & {
  ref?: React.Ref<HTMLDivElement>;
}) {
  const [openInternal, setOpenInternal] = useState(defaultValue);

  const open = openControlled ?? openInternal;
  const state = open ? 'open' : 'closed';
  const contentId = `${id}-content`;
  const triggerId = `${id}-trigger`;

  const toggleInternal = () => setOpenInternal((value) => !value);
  const toggle = toggleControlled ?? toggleInternal;

  return (
    <div ref={ref} className="group flex flex-col" data-state={state}>
      <button
        className={addClassName(
          'relative flex grow transition-all',
          triggerClassName,
        )}
        id={triggerId}
        type="button"
        aria-expanded={open}
        aria-controls={contentId}
        onClick={toggle}
      >
        {title}
        <SvgChevronRight
          className={addClassName(
            'absolute right-0 top-[50%] translate-y-[-50%] transition-all group-data-[state=closed]:rotate-90 group-data-[state=open]:-rotate-90',
            triggerIconClassName,
          )}
        />
      </button>
      <div
        className="grid grow overflow-hidden transition-all group-data-[state=closed]:grid-rows-[0fr] group-data-[state=open]:grid-rows-[1fr]"
        id={contentId}
        role="region"
        aria-hidden={!open}
        aria-labelledby={triggerId}
      >
        <div className="overflow-hidden">{children}</div>
      </div>
    </div>
  );
}
